import React from "react";
import MicrosoftIcon from "../../../assets/microsoft";
import GoogleCalendar from "../../../assets/googleCalendar";
import { Text } from "rizzui/typography";
import { ActionIcon } from "rizzui/action-icon";
import GoogleGIcon from "../../../assets/googleG";
import MsIcon from "../../../assets/msicon";
import ZohoIcon from "../../../assets/zoho";
import HubspotIcon from "../../../assets/hubspot";
import ApolloIcon from "../../../assets/apollo";
import ZendeskIcon from "../../../assets/zendesk";
import SlackIcon from "../../../assets/slack";
import cn from "../../../lib/utils/class-name";
import {
  useConnectCalendar,
  useUserCalendar,
} from "../../../hooks/useCalendar";
import SliderIcon from "../../../assets/slider";
import HubSpotCard from "./cards/hubspot";

export const Wrapper = ({ children }) => {
  return (
    <div className="w-full h-[214px] p-[24px] border-[.5px] rounded-[8px] border-[#D1D6DD] place-content-center">
      {children}
    </div>
  );
};
export const titleClassName =
  "font-[500] font-switzer text-primary-dark text-[16px] leading-[21.12px] mt-2";
export const subTitleClassName =
  "font-[400] font-switzer text-[#758599] text-[12px] leading-[15.84px] mb-[32px]";
export const btnClassName =
  "w-[210px] h-[35px] rounded-[4px] border border-primary-dark !bg-transparent text-primary-dark";
export const btnTextClassName =
  "font-gilroyMedium font-[400] text-[12px] leading-[14.56px] text-primary-dark ml-1";
export const disBtnClassName =
  "py-[1px] px-[12px] rounded-[4px] border border-[#D6D9DA] bg-[#D6D9DA] hover:bg-[#D6D9DA] min-w-[96px] w-auto h-[24px] mt-[24px]";
export const disBtnTextClassName =
  "font-switzer font-[400] text-[12px] leading-[22px] text-[#333F48]";

export default function Integration() {
  const { connect, isLoading } = useConnectCalendar();
  const { data: calendars } = useUserCalendar();
  return (
    <div className="gap-[32px] grid grid-cols-1 place-items-center lg:place-items-start lg:grid-cols-2 2xl:place-items-start 2xl:grid-cols-4 mt-[49px] w-full min-h-[450px] h-auto">
      <Wrapper>
        <GoogleCalendar className={""} />
        <div className="w-[176px]">
          <Text className={titleClassName}>Google calendar</Text>
          {calendars?.find(
            (calendar) => calendar?.calendar_name === "google"
          ) ? (
            <Text className={subTitleClassName}>
              Disconnect your google calendar account
            </Text>
          ) : (
            <Text className={subTitleClassName}>
              Connect to your google calendar account
            </Text>
          )}
        </div>

        {!calendars?.find(
          (calendar) => calendar?.calendar_name === "google"
        ) ? (
          <ActionIcon
            className={btnClassName}
            isLoading={isLoading}
            onClick={() => connect("google")}
          >
            <GoogleGIcon className={""} />
            <Text className={btnTextClassName}>Connect calendar</Text>
          </ActionIcon>
        ) : (
          <ActionIcon
            className={btnClassName}
            isLoading={isLoading}
            onClick={() => {}}
          >
            <GoogleGIcon className={""} />
            <Text className={btnTextClassName}>Disconnect calendar</Text>
          </ActionIcon>
        )}
      </Wrapper>

      <Wrapper>
        <MicrosoftIcon className={""} />
        <div className="w-[176px]">
          <Text className={titleClassName}>Microsoft calendar</Text>
          <Text className={subTitleClassName}>
            Connect to your microsoft calendar account
          </Text>
        </div>

        <ActionIcon variant="text" className={btnClassName}>
          <MsIcon className={""} />
          <Text className={btnTextClassName}>Connect calendar</Text>
        </ActionIcon>
      </Wrapper>

      <HubSpotCard />
      <Wrapper>
        <ZohoIcon className={""} />
        <div className="w-[176px]">
          <Text className={titleClassName}>Zoho</Text>
          <Text className={subTitleClassName}>
            Connect to your zoho <br />
            account
          </Text>
        </div>

        <ActionIcon variant="text" disabled className={disBtnClassName}>
          <Text className={disBtnTextClassName}>Coming soon</Text>
        </ActionIcon>
      </Wrapper>

      <Wrapper>
        <ApolloIcon className={""} />
        <div className="w-[176px]">
          <Text className={titleClassName}>Apollo</Text>
          <Text className={subTitleClassName}>
            Connect to your apollo <br /> account
          </Text>
        </div>

        <ActionIcon variant="text" disabled className={disBtnClassName}>
          <Text className={disBtnTextClassName}>Coming soon</Text>
        </ActionIcon>
      </Wrapper>

      <Wrapper>
        <ZendeskIcon className={""} />
        <div className="w-[176px]">
          <Text className={titleClassName}>Zendesk</Text>
          <Text className={subTitleClassName}>
            Connect to your zendesk workspace
          </Text>
        </div>

        <ActionIcon variant="text" disabled className={disBtnClassName}>
          <Text className={disBtnTextClassName}>Coming soon</Text>
        </ActionIcon>
      </Wrapper>

      <Wrapper>
        <SlackIcon className={""} />
        <div className="w-[176px]">
          <Text className={titleClassName}>Slack</Text>
          <Text className={subTitleClassName}>
            Connect to your slack workspace
          </Text>
        </div>

        <ActionIcon variant="text" disabled className={disBtnClassName}>
          <Text className={disBtnTextClassName}>Coming soon</Text>
        </ActionIcon>
      </Wrapper>

      <Wrapper>
        <Text className={cn(subTitleClassName, "text-center")}>
          We have more tools coming soon as well
        </Text>
      </Wrapper>
    </div>
  );
}
